/**
 * Hook for Google Drive Cache debugging
 */

import { useGoogleDriveCache } from "./useGoogleDriveCache";
import type { GoogleDriveCacheDebugInfo } from "../types";

export function useGoogleDriveCacheDebug(): GoogleDriveCacheDebugInfo {
  const cache = useGoogleDriveCache();

  return {
    ...cache.getCacheInfo(),
    clearCache: cache.clear,
    setTTL: (ttl: number) => cache.setConfig({ defaultTTL: ttl }),
    setMaxSize: (maxSize: number) => cache.setConfig({ maxSize }),
    invalidateAccount: (isSecondAccount: boolean) => cache.invalidatePattern({ isSecondAccount }),
    invalidateDrive: (driveId: string) => cache.invalidatePattern({ driveId }),
    invalidateAll: cache.clear,
  };
}
